import { useLazyQuery } from '@netfront/apollo-providers';

import { GET_ACTIVE_PLANS_QUERY } from './useGetActivePlans.graphql';
import {
  IGetActivePlans,
  IGetActivePlansQueryGraphQLResponse,
  IUseGetActivePlansOptions,
  IHandleGetActivePlansParams,
} from './useGetActivePlans.interfaces';

const useGetActivePlans = (options?: IUseGetActivePlansOptions): IGetActivePlans => {
  const { fetchPolicy, onCompleted, onError } = options ?? ({} as IUseGetActivePlansOptions);

  const { handleQuery: executeGetActivePlans, isLoading = false } = useLazyQuery({
    apiName: 'muriqui',
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
    // apollo-providers still calls onCompleted, with undefined data, when the request fails (e.g. a network error) and onError reports it
    onCompleted: (data?: IGetActivePlansQueryGraphQLResponse) => {
      if (!onCompleted || !data) {
        return;
      }

      const {
        plans: { getActivePlans: plans },
      } = data;

      onCompleted({
        plans,
      });
    },
    onError,
    query: GET_ACTIVE_PLANS_QUERY,
  });

  // Also returns the plans, so a caller can tell which request they belong to: onCompleted runs for every response
  const handleGetActivePlans = async ({ projectId, product }: IHandleGetActivePlansParams) => {
    // apollo-providers resolves to undefined when the request fails
    const data = (await executeGetActivePlans({
      product,
      projectId,
    })) as IGetActivePlansQueryGraphQLResponse | undefined;

    return data?.plans.getActivePlans;
  };

  return {
    handleGetActivePlans,
    isLoading,
  };
};

export { useGetActivePlans };
